import styled, { css } from 'styled-components';
import { layout } from '../../../package.json';

interface ContainerBoxProps {
  width?: string;
  height?: string;
  borderColor?: string;
}

interface TabProps {
  active?: boolean;
}

export const Root = styled.div`
  width: 100%;
  max-width: 1400px;
  padding: 0 2%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: var(--fontcolor);
  padding-bottom: 15px;

  .mg-b-16 {
    margin-bottom: 16px;
  }

  @media (max-width: ${layout.desktop}) {
    max-width: 700px;
  }
`;

export const ContainerBox = styled.div<ContainerBoxProps>`
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin: 25px auto;
  height: 100%;

  position: relative;
  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${props =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${props =>
    props.borderColor &&
    css`
      border: 1px solid ${props.borderColor};
    `};

    @media (max-width: ${layout.desktop}) {
      flex-direction: column;
      align-items: center;
    }
`;

export const ContainerProductImage = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 700px) {
      flex-direction: column;
      margin-right: 0;
      margin: 0 auto;
    }
  @media (min-width: 700px) {
    margin-right: 30px;
  }
`;

export const ContainerProductImageSlug = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 160px;

  height: 98%;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;

  @media (max-width: 700px) {
    width: 100%;
    max-width: 500px;
    overflow-y: hidden;
    overflow-x: hidden;
    direction: ltr !important;

    flex-direction: row;
    padding: 0 2%;
      button + button {
        margin-left:3px;
      }
  }
  @media (max-width: 400px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;

interface ProductImageSlugItem {
  bSelected?: boolean;
}

export const ProductImageSlugItem = styled.button<ProductImageSlugItem>`
  display: flex;
  justify-content: center;
  align-items: center;

  max-width: 120px;
  max-height: 120px;
  margin-bottom: 6px;

  @media (max-width: 400px) {
    width: 60px;
    height: 60px;
  }

  img {
    width: 90%;
  }

  cursor:pointer;
  ${props => props.bSelected ? 'border: 1px solid var(--primary);' : 'border: 2px solid #e2e2e2;'}
  border-radius: 10px;
`;

export const ContainerProductImagePreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid #ccc;

  
  width: 500px;
  height:500px;

  .loadingStyle{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 500px;
  }

  img {
    width: 98%;
    height: 98%;
    max-height:500px;
  }

  @media (max-width: 700px) {
    width: 100%;
    height: auto;
    max-width: 500px;
  }

  @media (max-width: 700px) {

    margin-top: 15px;
    .loadingStyle{
      width: auto;
      height: auto;
      max-width: 500px !important;
      max-height: 500px !important;
    }
  }


`;

export const ContainerProduct = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;

  @media (max-width: ${layout.desktop}) {
    max-width: 650px;
    justify-content: center;
  }
`;

export const ContainerProductDetails = styled.div`
  width: 100%;

  display: flex;

  @media (max-width: ${layout.desktop}) {
    align-items: center;
  }
`;

export const DetailsStar = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const DetailsEvaluation = styled.div`
  margin-left: 10px;
  font-size: 1.33rem;
`;

export const DetailsSKU = styled.div`
  color: var(--gray-light);
  @media (max-width: ${layout.desktop}) {
    margin-top: 30px;
  }
`;

export const ContainerProductTitle = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;

  span {
    color: #333;
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1.3;
    
    @media (max-width: ${layout.mobile}) {
      font-size: 1.5rem;
    }
  }
`;

export const ContainerProductStock = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  span {
    color: var(--green);
    font-weight: 600;
    font-size: 1rem;
    padding: 4px 12px;
    background-color: rgba(0, 200, 81, 0.1);
    border-radius: 50px;
    display: inline-block;
  }
`;

export const ContainerProductActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  max-width: 570px;
  min-height: 120px;
  border-radius: 20px;

  padding: 16px 24px;
  margin-top: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  @media (max-width: ${layout.mobile}) {
    flex-direction: column;
    min-height: 180px;
    padding: 16px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  
  @media (max-width: ${layout.mobile}) {
    width: 100%;
    justify-content: space-between;
    margin-top: 10px;
  }
`;

export const ContainerPrice = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: flex-start; */
  justify-content: center;

  flex: 1;
  padding: 0 8px;

  .reference-price {
    color: #666;
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 4px;
    order: 2;
  }

  .dynamic-price {
    color: #404040;
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 4px;
    order: 1;

    .unit {
      font-size: 1.2rem;
      font-weight: 400;
      color: #666;
    }
  }

  .single-price {
    color: #404040;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 4px;

    .unit {
      font-size: 1rem;
      font-weight: 400;
      color: #666;
    }
  }

  /* Manter compatibilidade com spans antigos */
  span:first-of-type {
    color: #404040;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 4px;
  }

  span:last-child {
    color: var(--gray);
    font-size: 1rem;
    font-weight: 500;
  }

  @media (max-width: ${layout.mobile}) {
    width: 100%;
    margin-bottom: 16px;
    align-items: center;
    text-align: center;
    
    .reference-price {
      font-size: 0.9rem;
    }

    .dynamic-price {
      font-size: 1.5rem;

      .unit {
        font-size: 1rem;
      }
    }

    .single-price {
      font-size: 1.3rem;

      .unit {
        font-size: 0.9rem;
      }
    }
    
    span:first-of-type {
      font-size: 1.8rem;
    }
  }
`;

interface AddCartProps {
  bCard: boolean;
}

export const AddCart = styled.div<AddCartProps>`
  width: 160px;
  height: 48px;
  border-radius: 50px;
  margin: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;

  display: flex;
  align-items: center;
  justify-content: center;
  
  background: ${props => props.bCard === false
    ? 'var(--primary-light)'
    : 'linear-gradient(to right, #ff5252, #ff1a1a)'};
  
  span {
    color: #fff;
    font-weight: 600;
    font-size: 1.1rem;
    transition: transform 0.2s ease;
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    
    span {
      transform: translateY(-1px);
    }
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: ${layout.mobile}) {
    width: 145px;
    height: 45px;
    margin: 0;
    
    span {
      font-size: 1rem;
    }
  }
`;

export const FavoriteCart = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  transition: all 0.2s ease-in-out;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #777;
    transition: all 0.2s ease;
    
    &:hover {
      color: var(--primary);
      transform: scale(1.1);
    }
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
    cursor: pointer;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const ContainerProductFeatured = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
  height: 100;
  h1 {
    margin-bottom: 15px;
  }
  > span {
    margin-bottom: 50px;
  }

  @media (max-width: ${layout.desktop}) {
    width: 100%;
  }
`;

export const ContainerTabs = styled.div`
  width: 50%;
`;

export const Tab = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  border-bottom: 3px solid var(--primary);
`;

export const TabTitle = styled.div<TabProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 150px;
  height: 50px;
  font-weight: 700;
  font-size: 1.25rem;

  ${props =>
    props.active &&
    css`
      background: var(--primary);
      color: #fff;
    `}

  :hover {
    background: var(--primary);
    color: #fff;
    cursor: pointer;
  }
`;

export const TabContent = styled.div`
  padding: 20px;
`;

export const ContainerSection = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
`;

export const ContainerTitle = styled.div`
  font-size: 1.62rem;
`;

export const ContainerWarranty = styled.div`
 padding: 24px 0;
 width: 100%;
 max-width: 570px;
 margin: 0 auto;
 
 > button {
   cursor: pointer;
   transition: transform 0.2s ease;
   
   &:hover {
     transform: translateY(-2px);
   }
   
   &:active {
     transform: scale(0.98);
   }
 }
`

export const ContentEspecificationItem = styled.div`
 width: 100%;
 max-width: 1400px;
 display:flex;
 flex-direction: column;
 align-items: center;
 margin-bottom: 50px;
`

export const ContainerItemAtributes = styled.div`
  display: flex;
  width: 100%;
  max-width: 570px;
  border-radius: 20px;
  padding: 20px;
  margin-top: 16px;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  }
`

export const MessageProductNotFound = styled.span`
  margin-top: 30px;
  padding: 2px;
  width: 100%;
  font-size: 28px;
  color: var(--primary);
  text-align: center;
`;
